import { useEffect } from "react";
import Modal from "../../../components/ui/Modal";
import { useTranslation } from "react-i18next";
import { useForm } from "react-hook-form";
import FieldError from "../../../components/ui/FieldError";
import RequiredField from "../../../components/ui/RequiredField";
import axiosConfig from "../../../services/Axios";
import { toast } from "react-toastify";
import { useNavigate } from "react-router-dom";
import { pickBy } from "lodash";

function CategorieCreateForm({
  modalCategorieFormIsOpen,
  setModalCategorieFormIsOpen,
}) {
  const form = useForm();
  let navigate = useNavigate();
  const { t } = useTranslation();

  const onSubmitCategorie = async (data) => {
    try {
      const sanitizedData = pickBy(
        data,
        (value) =>
          value !== null &&
          (value > 0 ||
            value.length > 0 ||
            (typeof value === "object" && !Array.isArray(value)))
      );
      await axiosConfig
        .post(
          process.env.REACT_APP_API_URL + "/api/item_categories",
          sanitizedData
        )
        .then((response) => {
          if (response?.status === 201 && response?.data) {
            toast.success(t("categories.created"), {
              theme: "colored",
              hideProgressBar: true,
            });

            setModalCategorieFormIsOpen(false);
            navigate(`/settings/categories/${response.data.id}`);
          }
        });
    } catch (e) {
      if (e.response?.status !== 200 && e.response?.data?.violations) {
        e.response.data.violations.map((v) => {
          form.setError(v.propertyPath, {
            type: "manual",
            message: v.message,
          });
        });
      } else {
        console.log(e);
      }
    }
  };

  useEffect(() => {
    form.reset();
  }, [modalCategorieFormIsOpen]);

  return (
    <div>
      {modalCategorieFormIsOpen && (
        <Modal
          showModal={modalCategorieFormIsOpen}
          setShowModal={setModalCategorieFormIsOpen}
          title={t("categories.create")}
          sendLabel={t("global.btn.save")}
          onSubmit={form.handleSubmit(onSubmitCategorie)}
        >
          <form onSubmit={form.handleSubmit(onSubmitCategorie)}>
            <div className="grid grid-cols-12 gap-3">
              <div className="col-span-12">
                <label>
                  {t("categories.name")}
                  <RequiredField /> :
                </label>
                <input
                  {...form.register("name")}
                  name="name"
                  type="text"
                  className="w-full"
                  aria-invalid={form.formState?.errors?.name ? true : false}
                />
                <FieldError error={form.formState?.errors?.name} />
              </div>
            </div>
          </form>
        </Modal>
      )}
    </div>
  );
}

export default CategorieCreateForm;
